/*
MIT License

Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

export type ClassValue =
  | ClassArray
  | string
  | number
  | bigint
  | null
  | boolean
  | undefined;

type ClassArray = ClassValue[];

function toVal(mix: NonNullable<ClassValue>) {
  let i: number;
  let y: string;
  let str = '';

  if (
    typeof mix === 'string' ||
    typeof mix === 'number' ||
    typeof mix === 'bigint'
  ) {
    str += mix;
  } else if (Array.isArray(mix)) {
    for (i = 0; i < mix.length; ++i) {
      const value = mix[i];
      if (value) {
        y = toVal(value);
        if (y) {
          if (str) str += ' ';
          str += y;
        }
      }
    }
  }

  return str;
}

/**
 * Conditionally join strings of class names together, filtering out falsy values.
 *
 * @example
 * cssJoin('bg-secondary', variant === 'primary' && 'text-primary')
 *
 * @param classes
 */
export function cssJoin(...classes: ClassValue[]) {
  let x: string;
  let str = '';

  for (let i = 0; i < classes.length; ++i) {
    const value = classes[i];
    if (value) {
      x = toVal(value);
      if (x) {
        if (str) str += ' ';
        str += x;
      }
    }
  }

  return str;
}
